<tn-dialog-shell testId="show-logs" [title]="'Logs' | translate">
  @if (job.logs_excerpt) {
    <div class="logs">
      <pre tnTestId="logs-excerpt" tnTestIdType="text"><code>{{ job.logs_excerpt }}</code></pre>
      <ix-copy-button [text]="job.logs_excerpt"></ix-copy-button>
    </div>
  }

  <div tnDialogAction>
    <tn-button
      variant="outline"
      testId="close"
      [label]="'Close' | translate"
      (onClick)="dialogRef.close()"
    ></tn-button>
    <tn-button
      color="primary"
      testId="download-logs"
      [label]="'Download Logs' | translate"
      (onClick)="downloadLogs()"
    ></tn-button>
  </div>
</tn-dialog-shell>
